import React, { useState, useEffect, useCallback } from "react";
import { Select, Row, Col, Form, Icon, Spin, DatePicker, Input, InputNumber, Button, Radio, Switch } from "antd";
import { BoldOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useHistory } from "react-router-dom"

import "./FormRegistro.scss";
import { Label } from "react-bootstrap";
import { Redirect } from 'react-router';
import 'moment/locale/es';
moment.locale('es');
export default function FormRegistroAdjudicacion(props) {
    //console.log("PROPS REGISTRO adju", props);
    //console.log("PROPS REGISTRO ya fech ",props.handleSubmit);

    let idMedida = false;

    const { getFieldDecorator } = props.form;

    const dateFormat = "DD-MM-YYYY";
    const timeFormat = "HH:mm";

    const [rangeDates, setRangeDates] = useState({
        minInicio: moment().startOf('day'),
        minFin: moment().startOf('day')
    });

    const [redirect, setRedirect] = useState({
        redirecting: false,
        url: "/reportes",
        idTipoDocumentacion: props.idTipoDocumentacion
    });

    const [verificacion, setVerificacion] = useState({
        numero: props.numVerificacion
    });

    

    const [enabledRangeDate, setEnabledRangeDate] = useState({
        fechaInicio: false,
        fechaFin: false,
    });
    const [disableSwitch, setDisableSwitch] = useState(props.opcion === 3 ? true : false);
    const [tipoCaptura, setTipoCaptura] = useState(props.activa);
    const [activa, setActiva] = useState(props.activa);
    const [fechaVerificacion, setFechaVerificacion] = useState(props.fecha !== null &&
        props.fecha !== undefined && props.fecha !== "" ? props.fecha : moment().format('DD-MM-YYYY'));
    useEffect(() => {
        if (fechaVerificacion) {
            // Asegurar que la fecha siempre sea un objeto moment
            const fechaMoment = moment.isMoment(fechaVerificacion) ? fechaVerificacion : moment(fechaVerificacion, dateFormat);
            props.form.setFieldsValue({ fechaVerificacion: fechaMoment });
        }
    }, [fechaVerificacion]);
    const onSwitchChange = (c, e) => {
        //console.log(c,"SWITCH c")
        //console.log(e,"SWITCH tc")
        //console.log(activa,"SWITCH activa")
        setActiva(c);
        //console.log(activa,"SWITCH activa1")

        props.form.validateFieldsAndScroll((err, values) => {

            if (!err) {

                values.verificacionActiva = c

                props.validaFormulario(values);
                console.log('Received values of form: ', values);
            }
        });
        //props.validaFormulario(c)
        /*props.form.validateFieldsAndScroll((err, values) => {
           //console.log("valores veri1", values)
         values.verificacionActiva=c 
          props.validaFormulario(props.form)
       }) */

    };


    //  //console.log("PROPS FECHA1",props.fecha )
    ////console.log("PROPS FECHA",fechaVerificacion )
    //   let history = useHistory()

    const handleCambiaVerificacion = (e) => {
        //console.log('Received cambios of form: ', e.target.value);
        props.handleCambio(e.target.value);

        //props.validaFormulario(e.target.value)
        // props.form.validateFieldsAndScroll((err, values) => {
        //   //console.log("valores veri", values)
        // values.numero=e.target.value

        //}) 

    };


    const cambiaFecha = (date) => {
        //console.log('fecha en e:', date.format("YYYY-MM-DD HH:mm:ss")); // Ver la fecha real que viene

        setFechaVerificacion(date);  // Guardar la fecha en el estado

        // Asegurar que el formulario usa el valor correcto
        props.form.setFieldsValue({
            fechaVerificacion: date,
        });

        props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                values.fechaVerificacion = date.format(dateFormat);
                props.validaFormulario(values);
                //console.log('Fecha final enviada:', values.fechaVerificacion);
            }
        });
    };

    const renderRedirectRegresar = () => {
        if (redirect.redirecting) {
            return <Redirect
                to={{
                    pathname: redirect.url,
                    state: {
                        idTipoDocumentacion: redirect.idTipoDocumentacion
                    }
                }}
            />
        }
    }


    const handleGuardaVerificacion = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll((err, values) => {
            //console.log("Activa1", e)
            if (!err) {

                activa === true ?
                    values.verificacionActiva = 1 :
                    values.verificacionActiva = 0;
                values.idMedida = props.idMedida
                props.handleSubmit(values);
                setFechaVerificacion(values.fechaVerificacion)
                //console.log('Received values of form: ', values);
            }
        });
    };

    const handleRangeNumber = (rule, value, callback) => {
        if (value && (value > rule.max || value < rule.min)) {
            callback(rule.message)
        }
        callback()
    }



    return (
        <div>
            {renderRedirectRegresar()}
            {//<h1 className="titulo-adjudicacion">{props.nombreArticulo}</h1>
            }

            <div>
                <Form onSubmit={handleGuardaVerificacion} layout="vertical">
                    <Row>
                        <Col span={6}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Número de verificación</label>
                            </Col>
                        </Col>
                        <Col span={6}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Fecha</label>
                            </Col>
                        </Col>
                        <Col span={4}>
                            <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Verificación activa</label>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={6}>

                            <Form.Item name="numero" hasFeedback>
                                {getFieldDecorator('numero', {
                                    initialValue: verificacion.numero,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Seleccione número de verificación.',
                                        }
                                    ],
                                })(
                                    <Col span={15}>
                                        <Radio.Group name="radiogroup"
                                            value={verificacion.numero}
                                            disabled={disableSwitch}
                                            onChange={
                                                handleCambiaVerificacion
                                            }
                                        >
                                            <Radio value={1}>1</Radio>
                                            <Radio value={2}>2</Radio>
                                        </Radio.Group></Col>
                                )}
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Col span={23}>
                               {
                               //console.log('inicio fecha:', fechaVerificacion)
                               }
                                <Form.Item name="fechaVerificacion" hasFeedback>
                                    {getFieldDecorator('fechaVerificacion', {
                                        initialValue: fechaVerificacion ? moment(fechaVerificacion, dateFormat) : null,
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione la fecha de la verificación.',
                                            }
                                        ],
                                    })(
                                        <DatePicker
                                            placeholder="Seleccione fecha"
                                            format={dateFormat}
                                            disabledDate={current => {
                                                return current.startOf('day') > moment().endOf('day')
                                            }}
                                            onChange={cambiaFecha}
                                            locale={'es'}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                        <Col span={4}>
                            <Col span={23}>
                                {//console.log("ACTIVA",activa)
                                }
                                <Form.Item name="verificacionActiva" hasFeedback>
                                    {getFieldDecorator('verificacionActiva', {
                                        initialValue: activa,
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione si esta activa la verificación.',
                                            }
                                        ],
                                    })(
                                        <Switch
                                            checkedChildren="Sí"
                                            unCheckedChildren="No"

                                            defaultChecked={activa}
                                            disabled={disableSwitch}
                                            onChange={onSwitchChange}
                                        />
                                    )}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span></span>
                                </Form.Item>
                            </Col>
                        </Col>
                        {idMedida &&
                            <Col span={3}>
                                <Col span={22}>
                                    <Form.Item name="idMedida">
                                        {getFieldDecorator('idMedida',
                                            {
                                                initialValue: props.idMedida
                                            })(

                                                <Input.TextArea
                                                    value={props.idMedida}
                                                    rows={1}
                                                    autoSize={{ minRows: 1, maxRows: 1 }}
                                                    allowClear={true}
                                                    disabled={true}

                                                />
                                            )}
                                    </Form.Item>
                                </Col>
                            </Col>
                        }
                    </Row>

                </Form>
            </div>
        </div>
    )
}